import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { formatMoney } from '../../common/utils/currency';

/**
 * Alerta "um produto da sua lista de desejos baixou de preço". O subject é o
 * próprio destinatário (User); nome e preço novo vêm de content() (data). Leva
 * ao produto para aproveitar a queda.
 */
export default class PriceDropNotification extends Notification {
  icon() {
    return 'fas fa-tags';
  }
  href() {
    const data = this.attrs.notification.content() ?? {};
    return app.route('marketplace.product', {
      id: data.product_id
    });
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.price_drop', {
      product: data.product_name,
      price: formatMoney(data.new_price)
    });
  }
  excerpt() {
    const data = this.attrs.notification.content() ?? {};
    return formatMoney(data.new_price);
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/PriceDropNotification', PriceDropNotification);